export default "__VITE_ASSET__CSEQEI1i__"